const pageNameKey = "copyAccessTokenLink";

export const copyAccessTokenLinkEn = {
  [pageNameKey]: {
    linkText: "Access Token",
    copySuccessText: "Access Token copied to Clipboard",
    copyErrorText: "Failed to copy Access Token to Clipboard",
    toolTipText: "Copy Access Token for API access",
  },
};

export const copyAccessTokenLinkPtBr = {
  [pageNameKey]: {
    linkText: "Token de acesso",
    copySuccessText: "Token de acesso copiado para a área de transferência",
    copyErrorText:
      "Falha ao copiar o Token de Acesso para a área de transferência",
    toolTipText: "Copiar token de acesso para acesso à API",
  },
};

export const copyAccessTokenLinkDe = {
  [pageNameKey]: {
    linkText: "Zugangstokens",
    copySuccessText: "Zugangstokens in die Zwischenablage kopiert",
    copyErrorText:
      "Fehler beim Kopieren des Zugangstokens in die Zwischenablage",
    toolTipText: "Zugangstokens für API Zugang",
  },
};

export const copyAccessTokenLinkZhHans = {
  [pageNameKey]: {
    linkText: "访问令牌",
    copySuccessText: "访问令牌已复制到剪贴板",
    copyErrorText: "无法将访问令牌复制到剪贴板",
    toolTipText: "复制访问令牌以进行API访问",
  },
};

export const copyAccessTokenLinkIt = {
  [pageNameKey]: {
    linkText: "Token di accesso",
    copySuccessText: "Token di accesso copiato negli appunti",
    copyErrorText: "Impossibile copiare il token di accesso negli appunti",
    toolTipText: "Copia il Token per avere accesso all'API",
  },
};

export const copyAccessTokenLinkEs = {
  [pageNameKey]: {
    linkText: "Token de acceso",
    copySuccessText: "Token de acceso copiado al portapapeles",
    copyErrorText: "No se pudo copiar el token de acceso al portapapeles",
    toolTipText: "Copiar token de acceso para el acceso API",
  },
};

export const copyAccessTokenLinkNl = {
  [pageNameKey]: {
    copyErrorText: "Fout bij het kopiëren van het toegangstoken naar klembord",
    copySuccessText: "Toegangstoken gekopieerd naar klembord",
    linkText: "Toegangstoken",
    toolTipText: "Toegangstoken kopiëren voor API-toegang",
  },
};

export const copyAccessTokenLinkTr = {
  [pageNameKey]: {
    copyErrorText: "Erişim Simgesi Panoya kopyalanamadı",
    copySuccessText: "Erişim Belirteci Panoya kopyalandı",
    linkText: "Erişim Jetonu",
    toolTipText: "API erişimi için Erişim Simgesini Kopyala",
  },
};
